<template>
  <div ref="dressCodeRef" class="dresscode-container">
    <h2 ref="tituloRef" class="titulo">DRESS CODE</h2>
    <p ref="subtituloRef" class="formal">FORMAL</p>

    <!-- Ícono -->
    <div class="icono-container">
      <img
        ref="parejaRef"
        src="@/assets/dresscode.svg"
        alt="Dress code ícono elegante"
      />
    </div>

    <!-- Colores reservados -->
    <p ref="p2Ref" class="descripcion colores-reservados">
      <strong>Colores reservados:</strong><br />
      Blanco para la novia 

  
    </p>

    <!-- Paleta de colores 
    <div ref="paletaRef" class="paleta-container">
      <img
        src="@/assets/palet.png"
        alt="Paleta de colores reservados"
        class="paleta-img"
      />
    </div>-->
    
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'DressCode',
  setup() {
    const dressCodeRef = ref(null)
    const tituloRef = ref(null)
    const subtituloRef = ref(null)
    const p2Ref = ref(null)
    const parejaRef = ref(null)
    const paletaRef = ref(null)

    onMounted(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const tl = gsap.timeline({
                defaults: { ease: 'power2.out' }
              })

              tl.fromTo(
                tituloRef.value,
                { opacity: 0, y: -10 },
                { opacity: 1, y: 0, duration: 0.4 }
              )
                .fromTo(
                  subtituloRef.value,
                  { opacity: 0, y: 10 },
                  { opacity: 1, y: 0, duration: 0.4 },
                  '-=0.15'
                )
                .fromTo(
                  parejaRef.value,
                  { opacity: 0, scale: 0.9 },
                  { opacity: 1, scale: 1, duration: 0.5 },
                  '-=0.1'
                )
                .fromTo(
                  p2Ref.value,
                  { opacity: 0, y: 10 },
                  { opacity: 1, y: 0, duration: 0.4 },
                  '-=0.1'
                )
                .fromTo(
                  paletaRef.value,
                  { opacity: 0, y: 10 },
                  { opacity: 1, y: 0, duration: 0.5 },
                  '-=0.1'
                )

              observer.unobserve(entry.target)
            }
          })
        },
        { threshold: 0.25 }
      )

      observer.observe(dressCodeRef.value)
    })

    return {
      dressCodeRef,
      tituloRef,
      subtituloRef,
      p2Ref,
      parejaRef,
      paletaRef
    }
  }
}
</script>

<style scoped>
.dresscode-container {
  background-color: #f2eee8;
  color: #1a1a1a;
  text-align: center;
  padding: 60px 20px;
  font-family: 'Playfair Display', serif;
}

.titulo {
  font-size: 28px;
  letter-spacing: 2px;
    color: #1a1a1a;

  margin-bottom: 0;
  font-weight: 500;
}

.formal {
  font-size: 15px;
  font-family: 'Poppins', sans-serif;
  font-style: italic;
  margin-top: 10px;
  margin-bottom: 18px;
  letter-spacing: 1.5px;
}

.descripcion {
  font-size: 16px;
  font-family: 'Playfair Display', serif;
  line-height: 1.6;
  margin-bottom: 18px;
}

.colores-reservados {
  font-size: 15px;
}

.icono-container img {
  width: 220px;
  margin: 10px auto 20px;
  opacity: 0;
  filter: brightness(0.5);
}

/* Paleta */
.paleta-container {
  margin-top: 10px;
  opacity: 0;
}

.paleta-img {
  max-width: 260px;
  width: 100%;
}
</style>
